import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import style from './CustomHealth.module.css';
import URL from '../../../constants/url';
import EmptyContentBox from '../../../components/box/EmptyContentBox';
import EmptyDiseaseBox from '../../../components/box/EmptyDiseaseBox';
import TopBannerBox from '../../../components/box/TopBannerBox';
import DiseaseInformation from '../../../components/box/DiseaseInformation';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';

import Skeleton from '@mui/material/Skeleton';

/**
 * 맞춤 질환 정보
 * @returns {Element}
 * @constructor
 */
const CustomHealth = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [value, setValue] = React.useState('1');
    const isSendingRef = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [dissInfoList, setDissInfoList] = useState([]);
    const [dissContentsList, setDissContentsList] = useState([]);
    const [checkedList, setCheckedList] = useState([]);

    useEffect(() => {
        getDissInfoList();
    }, []);

    // 체크된 목록 불러오기
    const getDissInfoList = async () => {

        if (isSendingRef.current) return;
        isSendingRef.current = true;
        setIsLoading(true);
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

        const url = "/homecare/disease/retrieveUsrCstmzDissInfoList";
        const reqBody = {
            usrInfoId : loginUser.usrInfoId
        }
        try {
            const res = await axiosApi.post(url, reqBody);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const dissInfoList = res.data.result.dissInfoList || [];
                const dissContentsList = res.data.result.dissContentsList || [];

                setDissInfoList(dissInfoList);
                setDissContentsList(dissContentsList);
            } else {
                setCheckedList([]);
            }
        } catch (err) {
            console.log(err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <div id="custom-health" className='inner-wrap'>
                <div className="top-banner-wrap">
                    <TopBannerBox type="typeC" />
                </div>


                {/* 연결병원이 없을시 */}
                {/* <div className='cont-box'>
                    <div className={style['no-hospital-box']}>
                        < EmptyContentBox target="on" />
                    </div>
                </div> */}

                {/* 설정된 질환 정보가 없을시 */}
                {/* <div className='cont-box'>
                    <div className={style['no-hospital-box']}>
                        < EmptyDiseaseBox />
                    </div>
                </div> */}

                {/* 연결병원이 있을시 */}
                <div className={style['cont-box']}>
                    <div className={style['top-tab-menu']}>

                        {/* 로딩 중일 때 스켈레톤 표시 */}
                        {isLoading && (
                            <>
                                <div className={'top-tab-head'} data-type="b">
                                    <TabList
                                            aria-label="lab API tabs example"
                                            variant="scrollable"
                                            scrollButtons={false}
                                            className={style['tab-lists']}
                                        >
                                            <Tab value="1" disableRipple style={{width:'80px'}}>
                                                <Skeleton variant="rectangular" width={100} height={32} style={{ borderRadius: '8px' }} />
                                            </Tab>
                                            <Tab value="2" disableRipple style={{width:'80px'}}>
                                                <Skeleton variant="rectangular" width={100} height={32} style={{ borderRadius: '8px' }} />
                                            </Tab>
                                            <Tab value="3" disableRipple style={{width:'80px', backgroundColor: '#E2E6EC'}}>
                                                <Skeleton variant="rectangular" width={100} height={32} style={{ borderRadius: '8px' }} />
                                            </Tab>
                                    </TabList>
                                </div>
                                <Skeleton variant="text" width={80} height={36} style={{ marginTop:'12px'}} />
                                <Skeleton variant="rectangular" width={'100%'} height={130} style={{ borderRadius: '8px'}} />
                                 
                                <Skeleton variant="text" width={80} height={36} style={{marginTop:'20px'}} />
                                <div className={'top-tab-head'} data-type="b">
                                    <TabList
                                            aria-label="lab API tabs example"
                                            variant="scrollable"
                                            scrollButtons={false}
                                            className={style['tab-lists']}
                                        >
                                            <Tab value="1" disableRipple style={{width:'80px'}}>
                                                <Skeleton variant="rectangular" width={100} height={32} style={{ borderRadius: '8px' }} />
                                            </Tab>
                                            <Tab value="2" disableRipple style={{width:'80px'}}>
                                                <Skeleton variant="rectangular" width={100} height={32} style={{ borderRadius: '8px' }} />
                                            </Tab>
                                            <Tab value="3" disableRipple style={{width:'80px', backgroundColor: '#E2E6EC'}}>
                                                <Skeleton variant="rectangular" width={100} height={32} style={{ borderRadius: '8px' }} />
                                            </Tab>
                                    </TabList>
                                </div>
                                <Skeleton variant="rectangular" width={'100%'} height={130} style={{ borderRadius: '12px', marginTop:'12px' }} />
                            </>
                        )}

                        {!isLoading && dissInfoList.length > 0 && (
                            <TabContext value={value}>
                                <div className={'top-tab-head'} data-type="b">
                                    <TabList
                                        onChange={handleChange}
                                        aria-label="lab API tabs example"
                                        variant="scrollable"
                                        scrollButtons={false}
                                        className={style['tab-lists']}
                                    >
                                        {dissInfoList?.map((_item, _idx) => {
                                            return <Tab label={_item.dissNm} value={(_idx + 1).toString()} disableRipple key={`dissInfo_${_idx}`}/>
                                        })}

                                        {/* <Tab label={dissInfoList[1]?.dissNm} value="2" disableRipple /> */}
                                        {/* <Tab label={dissInfoList[2]?.dissNm} value="3" disableRipple /> */}
                                    </TabList>
                                    <div className={style['btn-bg-box']}>
                                        <button
                                            className={style["setting-btn"]}
                                            onClick={() => {
                                                const checkedList = dissInfoList?.map(({ hblNo, dissNm }) => ({
                                                    hblNo,
                                                    dissNm
                                                }));
                                                navigate(URL.DISEASE_SETTING, { state: { checkedList : checkedList } });
                                            }}
                                            >
                                            질환설정
                                        </button>
                                    </div>
                                </div>

                                {dissInfoList?.map((_item, _idx) => {
                                    return (
                                        <TabPanel value={(_idx + 1).toString()} key={`dissTab_${_idx}`}>
                                            <DiseaseInformation data={_item} dissContentsList={dissContentsList} />
                                        </TabPanel>
                                    )
                                })}
                                {/* <TabPanel value="1">
                                    <DiseaseInformation data={dissInfoList[0]} />
                                </TabPanel>
                                <TabPanel value="2">
                                    <DiseaseInformation data={dissInfoList[1]} />
                                </TabPanel>
                                <TabPanel value="3">
                                    <DiseaseInformation data={dissInfoList[2]} />
                                </TabPanel> */}
                            </TabContext>
                        )}

                        {/* 데이터가 없을 때 */}
                        {!isLoading && dissInfoList.length === 0 && (
                            <div className='cont-box'>
                                <div className={style['no-hospital-box']}>
                                    <EmptyDiseaseBox/>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </>
    );
};

export default CustomHealth;
